import { TGenericObject } from '../global/types';

export const createGutterProps: (gutter: number) => TGenericObject[] = (
  gutter: number
) => [{ m: `-${gutter / 2}px` }, { p: `${gutter / 2}px` }];
